import { _ } from "../../core/polyglot/polyglot.js";
import { widget } from "@foretagsplatsen/widgetjs";

/**
 * `searchFieldWidget` renders a search input together with a
 * search button.
 *
 * Events: use `onChange` and `onSearch` to trigger searches.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} searchFieldWidget
 */
function ledgerSearchFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	let searchString = spec.searchString || "";

	that.onChange = my.events.createEvent();
	that.onSearch = my.events.createEvent();

	that.getSearchString = function () {
		return searchString;
	};

	that.renderContentOn = function (html) {
		let input;

		html.div(
			{ class: "input-group" },
			(html) => {
				input = html.input({
					type: "text",
					name: "search",
					class: "form-control",
					value: searchString,
				});
			},
			html.span(
				{ class: "input-group-btn" },
				html
					.button(
						{
							class: "btn btn-default",
							type: "button",
							"data-test": "search",
						},
						_("Search"),
					)
					.click(my.search),
			),
		);

		input.change(() => {
			my.setSearchString(input.asJQuery().val());
		});

		input.keyup((event) => {
			if (event.keyCode !== 13) {
				return;
			}
			my.search();
		});
	};

	my.setSearchString = function (newSearchString) {
		searchString = newSearchString;
		that.onChange.trigger(searchString);
	};

	my.search = function () {
		that.onSearch.trigger(searchString);
	};

	return that;
}

export default ledgerSearchFieldWidget;
